import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  model: any = {};
  waterBodies: WaterBody[] = [];
  @Input() placeholder = 'Try "Lake of the Ozarks"';
  @Input() defaultWbId = 60;
  @Input() searchRoute = 'all-for-hire';
  searchWaterBody: WaterBody = {} as WaterBody;

  public input = {
    value: null,
  };
  formCtrl: FormControl;
  filteredData: any;
  firstCall: boolean;

  constructor(private waterBodyDao: WaterBodyDAO, private router: Router) {
    this.formCtrl = new FormControl();
    this.filteredData = this.formCtrl.valueChanges.pipe(
      startWith(null),
      map((obj) => this.filterData(obj)),
    );
  }

  ngOnInit() {
    const waterBodySub = this.waterBodyDao
      .getById(this.defaultWbId)
      .subscribe((wb) => {
        this.model.defaultWaterBody = wb;
      });
    this.subs.push(waterBodySub);
    const waterBodiesSub = this.waterBodyDao.get().subscribe((wbs) => {
      this.waterBodies = wbs;
    });
    this.searchWaterBody = this.model.defaultWaterBody;
    this.firstCall = true;
  }

  search() {
    if (
      this.searchWaterBody &&
      this.searchWaterBody.id &&
      this.searchWaterBody.id !== -1
    ) {
      this.router.navigate([this.searchRoute, this.searchWaterBody.id]);
    }
  }

  onOptionSelect(selection, autocomplete?) {
    if (this.firstCall) {
      this.searchWaterBody = selection;
      this.search();
    }
  }

  onKey(event) {
    if (event.keyCode === 13) {
      this.search();
    }
  }

  searchGuess(guess) {
    this.searchWaterBody = guess;
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  filterData(val: string) {
    let temp = val
      ? this.waterBodies.filter((serviceType) =>
          new RegExp(val, 'gi').test(serviceType['name']),
        )
      : this.waterBodies;
    if (temp.length === 0) {
      temp.push({ name: 'No Results Found', id: -1 } as WaterBody);
    }
    return temp;
  }

  valueChanged(val) {
    this.firstCall = true;
    let guesses = this.filterData(val);
    if (guesses.length === 0) {
      this.waterBodies.push({ name: 'No Results Found', id: -1 } as WaterBody);
      guesses.push({ name: 'No Results Found', id: -1 } as WaterBody);
    }
    const guess = guesses[0];
    this.searchGuess(guess);
  }
}
